import { action, observable, makeObservable } from "mobx";

import { persistStore } from "src/lib/mobx/persistStore.ts";
import { scheduleAction } from "src/lib/mobx/scheduleAction.ts";

export class AppStore {
  constructor() {
    makeObservable(this);
  }
  @observable
  pointerType = "mouse";

  @action
  setPointerType(type: string) {
    this.pointerType = type;
  }

  @observable
  debugTranslations = false;

  @action
  setDebugTranslations(state: boolean) {
    this.debugTranslations = state;
  }

  @observable
  debugDbQueries = false;

  @action
  setDebugDbQueries(state: boolean) {
    this.debugDbQueries = state;
  }
}

export const appStore = new AppStore();

export const appStorePersistKey = {
  name: "app_store",
  version: "1.0",
};

const OLD_DEBUG_TRANSLATIONS_KEY = "debugTranslations";
const OLD_DEBUG_QUERIES_KEY = "debugQueries";

const migrateOldLocaleStorageState = () => {
  const debugTranslations = localStorage.getItem(OLD_DEBUG_TRANSLATIONS_KEY);
  const debugDbQueries = localStorage.getItem(OLD_DEBUG_QUERIES_KEY);

  if (debugDbQueries != null) {
    appStore.debugDbQueries = true;
    localStorage.removeItem(OLD_DEBUG_QUERIES_KEY);
  }
  if (debugTranslations != null) {
    appStore.debugTranslations = debugTranslations === "enabled";
    localStorage.removeItem(OLD_DEBUG_TRANSLATIONS_KEY);
  }
};

const { startPersisting } = persistStore(appStore, appStorePersistKey, [
  "debugDbQueries",
  "debugTranslations",
]);

startPersisting();
migrateOldLocaleStorageState();

const MAX_TIME_DB_QUERIES_DEBUG_ENABLED = 4 * 60 * 60 * 1000; // 4 hours

const automaticallyDisableQueryDebugging = ({ after }: { after: number }) => {
  scheduleAction({
    timeout: after,
    enabledWhen: () => {
      return appStore.debugDbQueries;
    },
    action: () => {
      appStore.debugDbQueries = false;
    },
    storageKey: {
      name: "lastTimeDebugDbQueriesEnabled",
      version: "1",
    },
  });
};

automaticallyDisableQueryDebugging({
  after: MAX_TIME_DB_QUERIES_DEBUG_ENABLED,
});
